module.exports = __webpack_public_path__ + "static/media/qualified-beauty.a308b3e3.jpg";